export default __webpack_public_path__ + "static/media/logo.90d3ea53.png";